import { render, staticRenderFns } from "./lens.vue?vue&type=template&id=f0bea5ea&scoped=true&"
import script from "./lens.vue?vue&type=script&lang=js&"
export * from "./lens.vue?vue&type=script&lang=js&"
import style0 from "./lens.vue?vue&type=style&index=0&id=f0bea5ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bea5ea",
  null
  
)

export default component.exports